import axios from "axios";
import APPCONFIG from "constants/appConfig";

export { /* OverviewControllerCleanup, */ fetchData,download };

const CancelToken = axios.CancelToken;
var source = CancelToken.source();

/* function OverviewControllerCleanup() {
//console.log("cleanup overview in controller");
  source.cancel("Operation canceled by the user.");
}
 */

async function fetchData(type,from,to,vendor) {
//console.log("fetchData");

  // always kill the current action. this is not good code practice.
  source.cancel("Operation canceled by the user.");

  // create new source
  source = CancelToken.source();
//console.log("set source");
//console.log(source);
  const axiosConfig = {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
    cancelToken: source.token
  };

  return new Promise(function(resolve, reject) {
    axios
      .post(APPCONFIG.appBackendHostname + "api/vendormasterdata/requests", {type:type,from:from.toLocaleDateString("de").replace("/", "."),to:to.toLocaleDateString("de").replace("/", "."),vendor:vendor}, axiosConfig)
      .then(res => {
//console.log("data received, go resolve");
        resolve(res.data.requests);
      })
      .catch(error => {
//console.log("error received");
        reject(error);
      });
  });
}

function download(data,user){
//console.log("download");

  source = CancelToken.source();
  const axiosConfig = {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
    cancelToken: source.token,
    responseType: "blob"
  };

  axios
      .post(
        APPCONFIG.appBackendHostname + "api/vendormasterdata/writeExcel",
        {
          data:data,
          user:user.name
         /*  data: this.state.data,
          user: this.props.registeredUser.name */
        },
        axiosConfig
      )
      .then(res => {
//console.log("written");


//console.log(res);
        let blob = new Blob([res.data]);
        let d = new Date().toLocaleDateString();
        downloadBlob(
          blob,
          "VendorMasterDataTool_" + d +".xlsx"
        );
      })
      .catch(error => {
//console.log("error");
//console.log(error);
        /* this.setState({
          ownUpdate: true,
          open: false,
          deleteActive: false,
          popOverLoading: "popOverLoading"
        }); */
      });



}




function downloadBlob(blob, name = "file.xlsx") {
  // Convert your blob into a Blob URL (a special url that points to an object in the browser's memory)
  const blobUrl = URL.createObjectURL(blob);

  // Create a link element
  const link = document.createElement("a");

  // Set link's href to point to the Blob URL
  link.href = blobUrl;
  link.download = name;

  // Append link to the body
  document.body.appendChild(link);

  // Dispatch click event on the link
  // This is necessary as link.click() does not work on the latest firefox
  link.dispatchEvent(
    new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window
    })
  );

  // Remove link from body
  document.body.removeChild(link);
}
